import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, generatePath } from 'react-router-dom';
import { routes } from '../../Helpers/Configuration';
import { canViewProcessingHistory } from '../../../utilities/actionCheck';
import Icon from '@ellucian/ds-icons/lib/es6/Icon';
import { Tooltip, IconButton } from '@ellucian/react-design-system/core';

const ExecutionHistoryButton = props => {
    const intl = useIntl();
    const history = useHistory();
    const { hasPermission } = props;
    const canViewExecutionHistory = useMemo(() => canViewProcessingHistory(hasPermission), [hasPermission]);

    const navigateToTransferJobs = useCallback(() => {
        const route = generatePath(routes.importsTransferJob, { id: props.id });        
        history.push(route, { from:props.locationState } ); 
    }, [history]);
    
    return (
        <>
            {canViewExecutionHistory &&
                <Tooltip title={intl.formatMessage({ id: 'adminProspectsImportsExecutionHistory' })}>
                    <IconButton onClick={navigateToTransferJobs} color="secondary">
                        <Icon name="history" aria-label={intl.formatMessage({ id: 'adminProspectsImportsExecutionHistory' })} />
                    </IconButton>
                </Tooltip>
            }
        </>
    );
};
export default ExecutionHistoryButton;
